import { State } from '@progress/kendo-data-query';
import { useMutation } from '@tanstack/react-query';

import { apiClient } from 'core/api/globals';

/**
 * Hook for exporting upload tracker data as CSV.
 * @returns Mutation for exporting data as CSV.
 */
export function useMutationExportUploadTrackerData() {
  return useMutation({
    mutationFn: async (dataState: State) => {
      const csvBlob = await apiClient.uploadTrackerClient.exportForKendoGrid(dataState);
      return { blob: csvBlob, filename: 'Uploads', type: 'csv' };
    },
  });
}
